import { Instagram, Twitter, Discord, Did } from '../interfaces'
import firebase from 'firebase/compat/app'
import { fs } from './FirebaseInit'
import {
  FirestoreDataConverter,
  DocumentData,
  QueryDocumentSnapshot,
} from '@firebase/firestore-types'

export const { Timestamp } = firebase.firestore

class TimestampConverter<T extends DocumentData> implements FirestoreDataConverter<DocumentData> {
  toFirestore(modelObject: DocumentData): DocumentData {
    return modelObject
  }

  fromFirestore(snapshot: QueryDocumentSnapshot): T {
    const data = snapshot.data()

    const converted = Object.keys(data).reduce<DocumentData>((accumulator, key) => {
      if (data[key] instanceof Timestamp) {
        accumulator[key] = data[key].toDate()
      } else {
        accumulator[key] = data[key]
      }

      return accumulator
    }, {})

    return converted as T
  }
}

// This helper function exposes a 'typed' version of firestore().collection(collectionPath)
// Pass it a collectionPath string as the path to the collection in firestore
// Pass it a type argument representing the 'type' (schema) of the docs in the collection
const envDataPoint = <T extends DocumentData>(
  collectionPath: string
): firebase.firestore.CollectionReference =>
  fs
    .collection('versions')
    .doc('2')
    .collection('environments')
    .doc(`${process.env.NEXT_PUBLIC_ENVIRONMENT}`)
    .collection(collectionPath)
    .withConverter(new TimestampConverter<T>())

const transcodingDataPoint = <T extends DocumentData>(
  collectionPath: string
): firebase.firestore.CollectionReference =>
  fs
    .collection('versions')
    .doc('2')
    .collection(collectionPath)
    .withConverter(new TimestampConverter<T>())

// Construct a database helper object
export const db = {
  // list your collections here
  twitter: envDataPoint<Twitter>('twitter'),
  instagram: envDataPoint<Instagram>('instagram'),
  discord: envDataPoint<Discord>('discord'),
  whitelist: envDataPoint('whitelists/create/creators'),
  secretLinks: envDataPoint('whitelists/create/links'),
  dids: envDataPoint<Did>('dids'),
  users: envDataPoint('users'),
  mints: envDataPoint('mints'),
  verifiedSocials: (address: string) => envDataPoint(`addresses/${address}/socials`),
  userVideos: (did: string) => envDataPoint(`users/${did}/videos`),
  profiles: envDataPoint(`profiles`),
  //new
  transcoding: transcodingDataPoint(`transcoding`),
  videos: envDataPoint(`videos`),
  secrets: (address: string) => envDataPoint(`users/${address}/secrets`),
  presales: (mint: string) => envDataPoint(`presales/${mint}/addresses`),
}
